// extracted by mini-css-extract-plugin
export default {"category-reports-display-section":"CategoryReportsDisplaySection_category-reports-display-section__S3NGf"};